import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { ApiService } from '@api/types';
import * as localDateAction from './../actions/localDate.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class LocalDateEffects {
  @Effect()
  getLocalDate$ = this.actions$.pipe(
    ofType(localDateAction.getLocalDate),
    switchMap(() => {
      return this.api.user.getUserLocalDate().pipe(
        map(res => localDateAction.getLocalDateSuccess(res)),
        catchError(err => of(localDateAction.getLocalDateFail(err)))
      );
    })
  );
  constructor(private actions$: Actions, private api: ApiService) {}
}
